import { useBehavior, useCheckBox } from '@libs/hooks';
import { TInputData, TWidgetProps } from '@libs/types';
import { camelCaseToKebabCase, getFieldName } from '@libs/utils';
import clsx from 'clsx';
import React, { Activity, useId } from 'react';
import { TCheckboxOption } from '../../types/options';
import { getInlineStyles } from '../../utils/styles';
import { TextCommon } from '../UI/Text/TextCommon';
import styles from './checkBoxSwitcher.module.css';

const Switcher = ({ widget }: TWidgetProps<TInputData, TCheckboxOption>) => {
    const id = useId();
    const data = widget.data ?? {};
    const options = widget.options ?? {};
    const label = data.messages?.label || data.label;
    const { handleChange, isChecked } = useCheckBox(widget);
    const { isDisabled, isHidden } = useBehavior(widget);

    return (
        <Activity mode={isHidden ? 'hidden' : 'visible'}>
            <div style={getInlineStyles({ margin: options.margin })} data-test={widget.uid}>
                <div className={clsx(styles.switchWrapper, isDisabled && styles.disabled)}>
                    <input
                        data-test={`input_${widget.uid}`}
                        className={styles.hide}
                        id={id}
                        type="checkbox"
                        name={getFieldName(options.autofill)}
                        autoComplete={camelCaseToKebabCase(options.autofill)}
                        disabled={isDisabled}
                        checked={isChecked}
                        onChange={handleChange}
                        tabIndex={data.tabIndex}
                    />
                    <div className={styles.switchInputBlock}>
                        {label && <TextCommon isWidget={false} content={label} options={{ textColor: 'grey_72_lc', margin: { right: 24 } }} />}
                        <label className={clsx(styles.switchControl, isDisabled && styles.disabled)} htmlFor={id} />
                    </div>
                </div>
            </div>
        </Activity>
    );
};
export { Switcher };
